import React from 'react';
import { useSelector } from 'react-redux';
import { browserHistory } from 'react-router';

import { Tab, Tabs } from '@material-ui/core';
import { ErrorBoundary, LoadingProgress, Snackbar } from 'core';
import { dropRight } from 'lodash';

import { selectLoading, selectMessage } from '@lib/selectors';

export default function Examples({ children, location: { pathname } }: any) {
  const message = useSelector(selectMessage);
  const loading = useSelector(selectLoading);
  let value = pathname;
  const tokens = pathname.split('/');
  if (tokens.length > 3) {
    // Use `/examples/patients` instead of `/examples/patients/5d5e9d2661b3a902d7a3c2f0`
    value = dropRight(tokens).join('/');
  }
  return (
    <div>
      <Tabs variant="fullWidth" value={value}>
        <Tab value="/examples/legacy" label="Patients Legacy" onClick={() => browserHistory.push('/examples/legacy')} />
        <Tab value="/examples/patients" label="Patients" onClick={() => browserHistory.push('/examples/patients')} />
        <Tab
          value="/examples/activities"
          label="Activities"
          onClick={() => browserHistory.push('/examples/activities')}
        />
        <Tab value="/examples/offers" label="Offers" onClick={() => browserHistory.push('/examples/offers')} />
        <Tab value="/examples/waitlists" label="Waitlists" onClick={() => browserHistory.push('/examples/waitlists')} />
        <Tab
          value="/examples/appointments"
          label="Appointments"
          onClick={() => browserHistory.push('/examples/appointments')}
        />
        <Tab
          value="/examples/chatActivities"
          label="Chat Activities"
          onClick={() => browserHistory.push('/examples/chatActivities')}
        />
      </Tabs>
      <ErrorBoundary>{children}</ErrorBoundary>
      <Snackbar content={message} variant={message.variant} />
      <LoadingProgress loading={loading} />
    </div>
  );
}
